import React, { useState } from 'react';
import { AtbDetails } from 'src/components/AtbModal/AtbModal';

import { Button } from '../Button/Button';
import { Modal } from '../Modal/Modal';
import { ModalHeader } from '../Modal/ModalHeader';
import { ModalBody } from '../Modal/ModalBody';
import { ModalFooter } from '../Modal/ModalFooter';
import { Svg } from '../Svg/Svg';

import { SummaryList } from './SummaryList';
import classes from './Summary.scss';

type Props = {
    products: AtbDetails[];
};

export const SummaryPopup: React.FC<Props> = (props) => {
    const { products } = props;
    const [showDialog, setShowDialog] = useState(false);
    const open = () => setShowDialog(true);
    const close = () => setShowDialog(false);

    const totalQty = products.reduce((acc, prod) => acc + prod.qty, 0);
    const title = `Customising ${products.length} product${products.length === 1 ? '' : 's'} (${totalQty} items)`;

    return (
        <>
            <Button className={classes.summaryOpen} onClick={open} variant="light" icon="right-of-text">
                {title}
                <Svg name="arrow-right" />
            </Button>
            <Modal type="sidebar" isOpen={showDialog} onDismiss={close}>
                <ModalHeader title={title} onDismiss={close} />
                <ModalBody>
                    <SummaryList products={products} />
                </ModalBody>
                <ModalFooter onDismiss={close} />
            </Modal>
        </>
    );
};
